<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.50031C10 3.20614 11.5287 2.51968 12.4961 3.37921L19.8232 9.89191C20.7182 10.6875 20.7183 12.0866 19.8232 12.8821L12.4961 19.3948C11.5288 20.2541 10.0003 19.5676 10 18.2737V16.387C10 15.8347 9.55228 15.387 9 15.387H6C4.8955 15.387 4.00012 14.4915 4 13.387V9.38703C4 8.28246 4.89543 7.38703 6 7.38703H9C9.55221 7.38703 9.99988 6.93921 10 6.38703V4.50031ZM12 6.38703C11.9999 8.04378 10.6568 9.38703 9 9.38703H6V13.387H9C10.6569 13.387 12 14.7302 12 16.387V17.1595L18.4951 11.387L12 5.61359V6.38703Z" fill="white"/>
    <path d="M2 7.38703C2.55228 7.38703 3 7.83474 3 8.38703V14.387C2.99988 14.9392 2.55221 15.387 2 15.387C1.44779 15.387 1.00012 14.9392 1 14.387V8.38703C1 7.83474 1.44772 7.38703 2 7.38703Z" fill="white"/>
  </svg>
</template>

<script>

export default {
  name: 'descriptionIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
